import React, { useContext, useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input,
} from "reactstrap";
import { Link } from "react-router-dom";
//import * as TBToolkit from "react-bootstrap-table2-toolkit";
// const ToolkitProvider = TBToolkit.default;
// const { Search } = TBToolkit;
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import { useMutation, useQuery } from "@apollo/client";
import { GET_EMAILFORWARDERS } from "./emailforwarders.query";
import AddEmailForwarder from "src/components/AddEmailForwarder/AddEmailForwarder";
import EditEmailForwarder from "src/components/EditEmailForwarder/EditEmailForwarder";
import { ThemeContext } from "src/helpers/themeContext";
import SweetAlert from "react-bootstrap-sweetalert";
import DeleteModal from "src/components/deleteModal/deleteModal";
import "./EmailForwarders.scss";

const EmailForwarders = () => {
  const [tableData, setTableData] = useState<any>([]);
  const [searchText, setSearchText] = useState("");
  const [forwarderModal, setForwarderModal] = useState(false);
  const [editForwarderModal, setEditForwarderModal] = useState(false);
  const [selectedForwarder, setSelectedForwarder] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [success_dlg, setsuccess_dlg] = useState(false);
  const [dynamic_description, setdynamic_description] = useState("");
  const Theme = useContext(ThemeContext);

  const columns = [
    {
      dataField: "Id",
      text: "Id",
      sort: true,
    },
    {
      dataField: "OrgName",
      text: "Org Name",
      sort: true,
    },
    {
      dataField: "APIAccountName",
      text: "API Name",
      sort: true,
    },
    {
      dataField: "EmailAddress",
      text: "Outgoing Email Address",
      sort: true,
    },
    {
      dataField: "RegEx",
      text: "Match Expression",
      sort: true,
    },
    {
      dataField: "IsDefault",
      text: "IsDefault",
      sort: true,
      formatter: (cell: boolean) => (cell ? "Yes" : "No"),
    },
    {
      dataField: "menu",
      isDummyField: true,
      text: "Action",
      formatter: (cellContent: any, row: any) => (
        <React.Fragment>
          <UncontrolledDropdown style={{ justifySelf: "flex-start" }}>
            <DropdownToggle tag="button" className="btn btn-light btn-sm">
              <i className="uil uil-ellipsis-h"></i>
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-end">
              <DropdownItem onClick={() => onEdit(row)}>
                <i className="mdi mdi-pencil font-size-16 text-success me-1"></i>
                Edit
              </DropdownItem>
              <DropdownItem onClick={() => setDeleteModal(row)}>
                <i className="mdi mdi-delete font-size-16 me-1"></i>
                Delete Forwarder
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </React.Fragment>
      ),
    },
  ];

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value);
  };

  const filteredData = tableData.filter((row: any) => {
    return Object.values(row).some((value: any) =>
      String(value).toLowerCase().includes(searchText.toLowerCase())
    );
  });

  const onEdit = (row: any) => {
    setEditForwarderModal(!editForwarderModal);
    setSelectedForwarder(row);
  };

  const defaultSorted: any = [
    {
      dataField: "id",
      order: "asc",
    },
  ];

  // Removed row selection checkbox column

  const pageOptions = {
    sizePerPage: 10,
    totalSize: tableData.length,
    custom: true,
  };
  // const { SearchBar } = Search;

  const { data, refetch } = useQuery(GET_EMAILFORWARDERS, {
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    if (data && data.msgbox_EmailParserOutgoingEmail) {
      var tmpData = data.msgbox_EmailParserOutgoingEmail
        .filter((item: any) => item.Organisation)
        .map(function (item: {
          EmailParserOutgoingEmailId: number;
          EmailAddress: string;
          RegEx: string;
          IsDefault: boolean;
          Organisation: { Name: string };
          APIAccount: { Name: string };
          APIAccountId: number;
        }) {
          return {
            Id: item.EmailParserOutgoingEmailId,
            APIAccountName: item.APIAccount?.Name,
            OrgName: item.Organisation.Name,
            EmailAddress: item.EmailAddress,
            IsDefault: item.IsDefault,
            RegEx: item.RegEx,
            APIAccountId: item.APIAccountId,
          };
        });
      setTableData(tmpData);
    }
  }, [data]);

  const toggleAddForwarderModal = () => {
    setForwarderModal(!forwarderModal);
  };

  const handleUserClicks = () => {
    toggleAddForwarderModal();
  };

  const refetchData = () => {
    refetch();
  };

  const handleDelete = async (forwarder: any) => {
    setDeleteModal(false);
    // Add your delete mutation here
    setsuccess_dlg(true);
    setdynamic_description(
      "Item will not be available to the user now, it will be permanently deleted in 60 days"
    );
    refetchData();
  };

  return (
    <React.Fragment>
      {success_dlg ? (
        <SweetAlert
          success
          title={Theme.name}
          onConfirm={() => {
            setsuccess_dlg(false);
          }}
        >
          {dynamic_description}
        </SweetAlert>
      ) : null}
      <DeleteModal
        isOpen={deleteModal !== false}
        cancel={() => setDeleteModal(false)}
        submit={() => handleDelete(deleteModal)}
      />

      <Card>
        <CardHeader>
          <Row>
            <Col md={6}>
              <div className="mb-3">
                <h4 className="card-title">All Email Forwarders</h4>
              </div>
            </Col>
            <Col md={6}>
              <div className="d-flex flex-wrap align-items-start justify-content-md-end mt-2 mt-md-0 gap-2 mb-3">
                <div>
                  <Link to="#" className="btn btn-light" onClick={refetchData}>
                    <i className="uil uil-refresh me-1"></i> Refresh
                  </Link>
                </div>
                <div>
                  <Link
                    to="#"
                    className="btn btn-light"
                    onClick={handleUserClicks}
                  >
                    <i className="uil uil-plus me-1"></i> Add New
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
        </CardHeader>
        <CardBody>
          <PaginationProvider pagination={paginationFactory(pageOptions)}>
            {({ paginationProps, paginationTableProps }) => (
              <React.Fragment>
                <Row className="mb-2">
                  <Col md="4">
                    <div className="search-box me-2 mb-2 d-inline-block">
                      <div className="position-relative">
                        <Input
                          type="text"
                          className="form-control"
                          placeholder="Search..."
                          value={searchText}
                          onChange={handleSearch}
                        />
                        <i className="bx bx-search-alt search-icon" />
                      </div>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col xl="12">
                    <div className="table-responsive">
                      <BootstrapTable
                        bordered={false}
                        striped={false}
                        defaultSorted={defaultSorted}
                        classes="table align-middle table-nowrap"
                        headerWrapperClasses="thead-dark"
                        headerClasses="table-dark"
                        {...paginationTableProps}
                        keyField="Id"
                        columns={columns}
                        data={filteredData}
                      />
                    </div>
                  </Col>
                </Row>

                <Row className="align-items-md-center mt-30">
                  <Col className="inner-custom-pagination d-flex">
                    <div className="d-inline">
                      <SizePerPageDropdownStandalone {...paginationProps} />
                    </div>
                    <div className="text-md-right ms-auto">
                      <PaginationListStandalone {...paginationProps} />
                    </div>
                  </Col>
                </Row>
              </React.Fragment>
            )}
          </PaginationProvider>
        </CardBody>
      </Card>

      <EditEmailForwarder
        modal={editForwarderModal}
        setModal={setEditForwarderModal}
        data={selectedForwarder}
        refresh={refetchData}
      />
      <AddEmailForwarder modal={forwarderModal} setModal={setForwarderModal} />
    </React.Fragment>
  );
};

export default EmailForwarders;
